import React from "react";
import { Form, Row } from "antd";
import BannerCard from "../../../common/components/BannerCard";
import InputFields from "../../../common/components/InputFields";
import getConfigs from "../../../GetConfigs";

const CaseSummaryCase = ({ ...props }) => {
  const { form } = props;
  const configurations = getConfigs([
    "ctFEDID",
    "ctSSN"
  ]);
  return (
    <BannerCard title="Case Details">
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <InputFields.InputTextField responsiveOptions={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 24 }} formItemName="CASE" formItemLabel="Case" condition="Y" />
          <InputFields.InputTextField responsiveOptions={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 24 }} formItemName="FILE_DATE" formItemLabel="File Date" condition="Y" />
          <InputFields.InputTextField responsiveOptions={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 24 }} formItemName="INCIDENT" formItemLabel="Incident" condition="Y" />
          <InputFields.InputTextField responsiveOptions={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 24 }} formItemName="FEDERAL_ID" formItemLabel="Alternate ID" condition={configurations.ctFEDID} />
          <InputFields.InputTextField responsiveOptions={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 24 }} formItemName="SSN" formItemLabel="SSN" condition={configurations.ctSSN} />
          <InputFields.InputTextField responsiveOptions={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 24 }} formItemName="STATUS" formItemLabel="Status" condition="Y" />
          <InputFields.InputTextField responsiveOptions={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 24 }} formItemName="NEXT_DATE" formItemLabel="Next Date" condition="Y" />
          <InputFields.InputTextField responsiveOptions={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 24 }} formItemName="NEXT_TIME" formItemLabel="Next Time" condition="Y" />
        </Row>
      </Form>
    </BannerCard>
  );
};

export default CaseSummaryCase;
